import { Rule, MarketSnapshot } from '../types';

export function evaluateRule(rule: Rule, snapshot: MarketSnapshot): boolean {
  if (!rule.enabled) return false;

  if (rule.fundingMin !== undefined && snapshot.funding < rule.fundingMin) return false;
  if (rule.fundingMax !== undefined && snapshot.funding > rule.fundingMax) return false;
  if (rule.oiTrend && snapshot.oiTrend !== rule.oiTrend) return false;
  if (rule.liqTrend && snapshot.liqTrend !== rule.liqTrend) return false;
  if (rule.priceTrend) {
    if (rule.priceTrend === 'up' && snapshot.priceChange24h <= 0) return false;
    if (rule.priceTrend === 'down' && snapshot.priceChange24h >= 0) return false;
  }

  return true;
}

export function getActiveRules(rules: Rule[], snapshot: MarketSnapshot | null): Rule[] {
  if (!snapshot) return [];
  return rules.filter(rule => evaluateRule(rule, snapshot));
}
